module.exports = __webpack_public_path__ + "static/img/zhoupu.ff30a0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/zhoupu.png
// module id = s97z
// module chunks = 0